import { render, staticRenderFns } from "./handfile.vue?vue&type=template&id=12840e1d"
import script from "./handfile.vue?vue&type=script&lang=js"
export * from "./handfile.vue?vue&type=script&lang=js"
import style0 from "./handfile.vue?vue&type=style&index=0&id=12840e1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports